import React from 'react'
import { Info, CheckCircle2 } from 'lucide-react'

/** Honest note on screens whose settings are stored here but not (yet) applied by queza-core. */
const NoticeBanner: React.FC<{ children: React.ReactNode; tone?: 'info' | 'warn' | 'ok' }> = ({ children, tone = 'warn' }) => (
  <div
    className={`flex items-start gap-2.5 rounded-xl border px-4 py-3 text-sm ${
      tone === 'warn' ? 'bg-amber-50 border-amber-200 text-amber-800' : tone === 'ok' ? 'bg-emerald-50 border-emerald-200 text-emerald-800' : 'bg-indigo-50 border-indigo-200 text-indigo-800'
    }`}
  >
    {tone === 'ok' ? <CheckCircle2 className="h-4 w-4 mt-0.5 flex-shrink-0" /> : <Info className="h-4 w-4 mt-0.5 flex-shrink-0" />}
    <div>{children}</div>
  </div>
)

export default NoticeBanner
